import { render, staticRenderFns } from "./container.vue?vue&type=template&id=06c61b6a&"
import script from "./container.vue?vue&type=script&lang=ts&"
export * from "./container.vue?vue&type=script&lang=ts&"
import style0 from "./container.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports